<template>
  <div class="profile-widget-section">
    <div class="profile-section-header">
      <div class="header-options">
        <button class="btn-menu" @click="toogleProfileSection()">
          <img src="@/assets/cv-editor-icons/tab-menu.svg" />
        </button>
      </div>
      <div class="profile-info">
        <h4 v-if="APPLICATION_NAME == 'consultified'">Teams</h4>
        <h4 v-if="APPLICATION_NAME == 'meritios'">Classes</h4>
      </div>
    </div>
    <div class="profile-section-body">
      <div class="student-profile-widget">
        <profilesList @consultantSelected="selectedProfile" @departmentSelected="departmentSelected"
          @teamSelected="teamSelected"></profilesList>
      </div>
    </div>
  </div>
</template>
<script>
import profilesList from "./profiles_list.vue";
import { eventBus } from "@/main";
export default {
  name: "editor-menu",
  components: {
    profilesList,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProfileMinimized: false,
      profile_data: null,
      selected_profile: null,
    };
  },
  computed: {},
  watch: {},
  mounted() { },
  methods: {
    departmentSelected(department) {
      eventBus.$emit("departmentSelected", department);
    },
    teamSelected(team) {
      eventBus.$emit("teamSelected", team);
    },
    toogleProfileSection() {
      let vm = this;
      vm.$emit("input", !vm.value);
    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "tools",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "domains",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "competences",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.name,
              priority: item.priority,
              editMode: false,
              type: "roles",
              order: item.order,
              status: item.status,
              searchable: item.status === 0 ? false : true,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                id: item.id,
                name: item.lang.name,
                lang: item.lang.id,
                editMode: false,
                type: "languages",
                order: item.order,
                status: item.status,
                searchable: item.status === 0 ? false : true,
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
            }
          });
        });
      }
      skills.tools.sort((start, end) => {
        return start.order - end.order;
      });
      skills.domains.sort((start, end) => {
        return start.order - end.order;
      });
      skills.languages.sort((start, end) => {
        return start.order - end.order;
      });
      skills.competences.sort((start, end) => {
        return start.order - end.order;
      });
      skills.roles.sort((start, end) => {
        return start.order - end.order;
      });
      return skills;
    },
    selectedProfile(profile) {
      let vm = this;
      vm.selected_profile = profile;
      vm.$emit("profileSelected", profile);
      eventBus.$emit("profileSelected", profile);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.profile-widget-section {
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  width: 200px;
  height: 100%;
  transition: 500ms ease-in-out;
  display: flex;
  flex-direction: column;

  .profile-section-header {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;

    .header-options {
      display: flex;
      align-items: center;

      .btn-menu {
        background: transparent;
        border: none;

        img {
          width: 18px;
        }
      }

      .btn-back {
        margin-left: 10px;
        border: 1px solid #1ba5a4;
        color: #1ba5a4;
        border-radius: 5px;
        height: 30px;
      }
    }

    .profile-info {
      display: flex;
      align-items: center;
      transform: rotate(0deg);
      position: relative;
      top: 0px;
      transition: 500ms ease-in-out;

      h4 {
        color: #707070;
      }
    }
  }

  .profile-section-body {
    padding: 0px 5px;
    opacity: 1;
    transition: 3000ms ease-in-out;
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .main-options {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0px 50px;

      .btn-design-temp {
        background: #1ba5a4;
        border-radius: 10px;
        font-size: 15px;
        text-align: center;
        color: #ffffff;
        margin-bottom: 20px;
        height: 50px;
        border-radius: 10px;
      }

      .btn-create-cv {
        border: 1px solid #1ba5a4;
        border-radius: 10px;
        font-size: 15px;
        height: 50px;
        color: #1ba5a4;
      }
    }

    .student-profile-widget {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  &.minimized {
    width: 50px;
    transition: 500ms ease-in-out;

    .profile-section-header {
      height: unset;
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      padding-right: 15px;
      padding-top: 20px;

      .btn-menu {
        background: transparent;
        border: none;
      }

      .profile-info {
        display: flex;
        align-items: center;
        transform: rotate(-90deg);
        position: relative;
        top: 27px;
        transition: 500ms ease-in-out;

        .icon {
          width: 22px;
          margin-right: 5px;
        }
      }
    }

    .profile-section-body {
      opacity: 0;
      transition: 10ms ease-in-out;
    }
  }
}
</style>